import React, {useEffect, useState} from 'react'
import {useSubscription} from "@apollo/client";
import gql from 'graphql-tag'

import authManager from '../lib/authManager';
import SidebarLayout from "./sidebar/SidebarLayout";
import SidebarMenu, {SidebarBottomMenu} from "./sidebar/SidebarMenu";

export default function SideBar({match, isCollapsed, setIsCollapsed}) {
    const [notification, setNotification] = useState(false)
    const {data = {}, loading} = useSubscription(gql`
        subscription notificationComment {
            notificationComment { createdById }
        }
    `, { fetchPolicy: 'no-cache', shouldResubscribe: true})

    useEffect(() => {
        const comment = data?.notificationComment;
        if (!loading && comment && comment.createdById !== authManager.userId && comment.createdById !== "") {
            setNotification(true)
        } else {
            setNotification(false)
        }
    }, [data, loading])

    return (
        <SidebarLayout
            isCollapsed={isCollapsed}
            setIsCollapsed={setIsCollapsed}
            renderNav={(props) => (
                <SidebarMenu {...props} match={match} notification={notification} />
            )}
            renderBottom={(props) => (
                <SidebarBottomMenu {...props} match={match} />
            )}
        />
    );
}